<template>
  <div style="height: 100%">
    <!-- sidebar -->
    <div id="sidebar" :class="[{ 'sidebar-hide': sidebarHide }]">
      <!-- <div class="" style="cursor: pointer" @click="$router.push('/')">
        <img
          height="50px"
          :src="baseUrl + 'img/logo-light-1.svg'"
          style="margin-left: 10px; margin-bottom: 20px"
        />
      </div> -->
      <router-link style="cursor: pointer" to="/">
        <img
          height="50px"
          :src="baseUrl + 'img/logo-light-1.svg'"
          style="margin-left: 10px; margin-bottom: 20px"
        />
      </router-link>

      <div class="sidebar-menu-container">
        <div>
          <ul class="sidebar-menu">
            <li>
              <!-- <router-link
              class="sidebar-link btn-success"
                to="/teste_pdv"
                v-if="this.$acl.can('orderCreateEdit')"
              >
                <i class="fas fa-cash-register" /> PDV
   
              </router-link> -->
              <router-link
                :class="[
                  'sidebar-link',
                  { 'sidebar-link-active': activePage == 'dashboard' },
                ]"
                to="/dashboard"
                v-if="canAccessUsers"
              >
                <i class="fas fa-chart-bar" /> Dashboard
                <!-- <span
                  style="text-indent: 0px"
                  class="badge badge-info text-white"
                  >Beta</span
                > -->
              </router-link>

              <router-link
                v-if="this.$acl.can('personIndex')"
                :class="[
                  'sidebar-link',
                  { 'sidebar-link-active': activePage == 'person' },
                ]"
                to="/pessoas"
              >
                <i class="fas fa-users" /> Pessoas
              </router-link>
              <router-link
                v-if="this.$acl.can('productIndex')"
                :class="[
                  'sidebar-link',
                  { 'sidebar-link-active': activePage == 'product' },
                ]"
                to="/produtos"
              >
                <i class="fas fa-box" /> Produtos
              </router-link>

              <!-- 
              <router-link 
              <router-link
                v-if="this.$acl.can('orderIndex') == 1"
                :class="[
                  'sidebar-link',
                  { 'sidebar-link-active': activePage == 'order' },
                ]"
                to="/vendas"
              >
                <i class="fas fa-shopping-cart" /> Vendas
              </router-link>

            <router-link
                v-else
                :class="[
                  'sidebar-link',
                  { 'sidebar-link-active': activePage == 'OrderForm'},
                ]"
                to="/vendas/venda/novo"
              >
                <i class="fas fa-shopping-cart" /> Nova Venda
              </router-link> -->

              <router-link
                v-if="this.$acl.can('orderIndex')"
                :class="[
                  'sidebar-link',
                  { 'sidebar-link-active': activePage == 'order' },
                ]"
                to="/vendas"
              >
                <i class="fas fa-shopping-cart" /> Vendas
              </router-link>

              <router-link
                v-if="
                  (this.$acl.can('orderIndex') == false) &
                  (this.$acl.can('orderCreateEdit') == true)
                "
                :class="[
                  'sidebar-link',
                  { 'sidebar-link-active': activePage == 'neworder' },
                ]"
                to="/vendas/venda/novo"
              >
                <i class="fas fa-shopping-cart" />
                Nova Venda
              </router-link>

              <router-link
                v-if="hasModuleNfe"
                style="color: rgb(175, 187, 199)"
                :class="[
                  'sidebar-link',
                  { 'sidebar-link-active': activePage == 'invoice' },
                ]"
                to="/nf-e"
              >
                <i class="fas fa-file-invoice" /> Notas Fiscais
              </router-link>

              <router-link
                v-if="this.$acl.can('purchaseIndex')"
                :class="[
                  'sidebar-link',
                  { 'sidebar-link-active': activePage == 'purchase' },
                ]"
                to="/compras"
              >
                <i class="fas fa-dolly-flatbed" /> Compras
              </router-link>

              <router-link
                v-if="this.$acl.can('accountTransactionIndex')"
                :class="[
                  'sidebar-link',
                  { 'sidebar-link-active': activePage == 'account' },
                ]"
                to="/caixas"
              >
                <i class="fas fa-coins" /> Contas e Caixas
              </router-link>

              <router-link
                v-if="this.$acl.can('billReceiveIndex')"
                :class="[
                  'sidebar-link',
                  { 'sidebar-link-active': activePage == 'billreceiveble' },
                ]"
                to="/contasareceber"
              >
                <i class="fas fa-file-invoice-dollar" /> Contas a Receber
              </router-link>

              <router-link
                v-if="this.$acl.can('billPaymentIndex')"
                :class="[
                  'sidebar-link',
                  { 'sidebar-link-active': activePage == 'billpayable' },
                ]"
                to="/contasapagar"
              >
                <i class="fas fa-file-invoice-dollar" /> Contas a Pagar
              </router-link>

              <router-link
                :class="[
                  'sidebar-link',
                  { 'sidebar-link-active': activePage == 'user' },
                ]"
                to="/usuarios"
                v-if="canAccessUsers"
              >
                <i class="fas fa-user" /> Usuários
              </router-link>

              <router-link
                v-if="canAccessUsers"
                style="color: rgb(175, 187, 199)"
                :class="[
                  'sidebar-link',
                  { 'sidebar-link-active': activePage == 'company' },
                ]"
                to="/empresas"
              >
                <i class="fas fa-building" /> Minha Empresa
                <!-- <span style="text-indent:0px" class="badge badge-secondary">Em Breve</span> -->
              </router-link>
              <div
                block
                class="text-left sidebar-link"
                variant="primary"
                @click="logout"
              >
                <i class="fas fa-sign-out-alt" /> Sair
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- sidebar -->

    <!-- top nav -->
    <div
      id="top-navbar"
      :class="['top-navbar', { 'content-fullwidth': sidebarHide }]"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 d-flex justify-content-between">
            <div class="d-flex justify-content-between">
              <button
                class="btn btn-top-navbar btn-transparent m-0"
                @click="toogleSidebar"
              >
                <i class="fas fa-bars"></i>
              </button>
            </div>
            <div class="d-flex align-items-center">
              <top-nav-tools />
              <top-nav-notifications />
              <top-nav-user-button />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- top nav -->

    <!-- content -->
    <div
      id="content"
      :class="['content', { 'content-fullwidth': sidebarHide }]"
    >
      <transition-group name="fade" mode="out-in">
        <div v-show="pageIsLoading" key="pageIsLoading">
          <h4 class="text-secondary mt-4 ml-5">Carregando...</h4>
        </div>

        <div v-show="pageLoadedWithError" key="pageLoadedWithError">
          <h4 class="text-secondary mt-4 ml-5">Erro ao carregar a pagina!</h4>
        </div>

        <div v-show="pageLoadedWithSuccess" class="container-fluid" key="view">
          <subscription-alert />
          <SubscriptionsNotPayed />
          <!-- pg alert -->
          <slot></slot>
        </div>
      </transition-group>
    </div>
    <!-- content -->
    <!-- <subscription-alert-modal /> -->
    <certificate-expiration-alert />
    <app-loading :show="showLoading" />
  </div>
</template>

<script>
import SubscriptionAlert from "./../components/subscription/sections/SubscriptionAlert";
import TopNavUserButton from "./../components/sections/TopNavUserButton";
import TopNavNotifications from "./../components/sections/TopNavNotifications";
import Echo from "laravel-echo";
import Pusher from "pusher-js";
import TopNavTools from "../components/sections/TopNavTools.vue";
import CertificateExpirationAlert from "../components/subscription/sections/CertificateExpirationAlert.vue";
import SubscriptionsNotPayed from "@/components/subscription/sections/SubscriptionsNotPayed.vue";
// import SubscriptionAlertModal from "../components/subscription/sections/SubscriptionAlertModal.vue";

export default {
  components: {
    TopNavUserButton,
    TopNavNotifications,
    SubscriptionAlert,
    TopNavTools,
    CertificateExpirationAlert,
    SubscriptionsNotPayed
    // SubscriptionAlertModal,
  },

  data: function () {
    return {
      echo: null,
      sidebarHide: false,
    };
  },

  computed: {
    baseUrl() {
      return process.env.BASE_URL;
    },

    showLoading() {
      return this.$store.state.loading;
    },

    alert() {
      return this.$store.state.appAlert;
    },

    activePage() {
      return this.$store.state.activePage;
    },

    pageLoadedWithSuccess() {
      return (
        this.$store.state.pageHasLoaded &&
        this.$store.state.userHasLoaded &&
        !this.$store.state.pageError
      );
    },

    pageLoadedWithError() {
      return (
        this.$store.state.pageHasLoaded &&
        this.$store.state.userHasLoaded &&
        this.$store.state.pageError
      );
    },

    pageIsLoading() {
      return (
        !this.$store.state.pageHasLoaded || !this.$store.state.userHasLoaded
      );
    },

    user() {
      return this.$store.state.user;
    },

    companyName() {
      if (this.$store.state.company.alias == null) {
        return this.$store.state.company.name;
      }

      return this.$store.state.company.alias;
    },

    canAccessUsers() {
      if (!this.$store.state.user) {
        return false;
      }

      if (
        this.$store.state.user.is_master_user != 1 &&
        this.$store.state.user.is_admin_user != 1
      ) {
        return false;
      }

      return true;
    },

    hasModuleNfe() {
      if (this.$store.state.company.module_nfe_active != 1) {
        return false;
      }

      return true;
    },
  },

  mounted() {
    // console.log(this.$acl.can('billReceiveIndex'))
  },

  methods: {
    toogleSidebar() {
      this.sidebarHide = !this.sidebarHide;
    },

    logout() {
      axios.post(process.env.BASE_URL + "api/logout").then((response) => {
        this.$store.dispatch("auth/loggout");
        this.$router.push("/login");
      });
    },
  },
};
</script>

<style lang="scss">
[v-cloak] {
  visibility: hidden;
  -webkit-font-smoothing: antialiased;
}

.fade-enter-active {
  transition-duration: 0.2s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active,
.fade-leave-to {
  opacity: 0;
}

.top-navbar {
  width: 100%;

  padding-top: 10px;
  padding-bottom: 5px;

  margin-bottom: 15px;

  padding-left: 280px;

  transition: all 0.3s ease;
}

.content {
  //background-color: #eaeef2;
  width: 100%;

  padding: 10px;

  padding-top: 5px;

  padding-left: 260px;

  padding-bottom: 100px;

  //height: 100%;

  transition: all 0.3s ease;
}

.content-fullwidth {
  padding-left: 10px;
}

#sidebar {
  color: #fff;

  width: 250px;
  height: 100%;
  padding: 20px;
  padding-top: 40px;
  position: fixed;
  z-index: 1020;

  //  display: flex;
  // flex-direction: column;
  //  justify-content: space-between;

  background-color: #1c2f44;

  box-shadow: 0px 0px 25px 0 rgba(69, 65, 78, 0.1);

  transition: all 0.3s ease;

  overflow-y: scroll;
}

.sidebar-hide {
  margin-left: -250px;
}

.sidebar-menu-brand {
  height: 50px;
}

@media (max-width: 768px) {
  .content {
    padding-left: 10px;

    padding-top: 80px;
  }

  .top-navbar {
    position: fixed;
    z-index: 1020;
    padding-left: 10px;
    background-color: #1c2f44;
  }

  #sidebar {
    margin-top: 60px;

    position: fixed;

    margin-left: -250px;

    padding-top: 5px;

    z-index: 1040;

    height: calc(100% - 60px);
  }

  .sidebar-hide {
    margin-left: 0px !important;
  }

  .btn-top-navbar {
    color: #fff !important;
    background-color: #1c2f44 !important;
    border: 1px solid #1c2f44 !important;
  }
}

.sidebar-menu-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: calc(100% - 50px);
}

.sidebar-menu {
  list-style: none;

  padding-left: 0px;
}

.sidebar-menu li {
  padding-left: 0px;

  height: 50px;

  text-indent: 5px;

  line-height: 40px;
}

.sidebar-link {
  cursor: pointer;

  color: rgb(175, 187, 199);

  display: block;

  white-space: nowrap;

  text-decoration: none;

  border-radius: 0.2rem;

  margin-bottom: 10px;
}

.sidebar-link i {
  margin-right: 5px;
}

.sidebar-link-active {
  color: #fff;

  text-decoration: none;

  background-color: #25476a;
}

.sidebar-link:hover {
  color: #fff;

  text-decoration: none;

  background-color: #25476a;
}
</style>
